import { cn } from "@prostocheck/shared";

import { ICardProps } from "./card.models";

export const Card = ({ children, className }: ICardProps) => (
  <div
    className={cn(
      "rounded-card bg-surface p-6 shadow-card ring-1 ring-ink-900/8",
      className,
    )}
  >
    {children}
  </div>
);
